export default function registerSubNav(Alpine) {
  Alpine.data('subNav', () => ({
    active: '',
    init() {
      const links = this.$el.querySelectorAll('[data-sub-nav-link]')
      if (!links.length) return

      const sections = [...links]
        .map((link) => document.getElementById(link.dataset.targetId))
        .filter(Boolean)

      if (!sections.length) return

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.active = entry.target.id
            }
          })
        },
        { rootMargin: '-20% 0px -60% 0px', threshold: 0 },
      )

      sections.forEach((section) => observer.observe(section))

      if (window.location.hash) {
        this.active = window.location.hash.slice(1)
      }
    },
  }))
}
